module.exports = __webpack_public_path__ + "static/media/marker-turaanadaa.c4a58274.png";